export default function Footer() {
  return <footer className="workspace-footer"><span>Perform © {new Date().getFullYear()}</span><span className="footer-note">Un peu mieux, chaque jour.</span></footer>;
}
